module.exports = {
  POOL_MEMBERSHIP_MANAGEMENT_SAVE_REQUEST: 'POOL_MEMBERSHIP_MANAGEMENT_SAVE_REQUEST',
  POOL_MEMBERSHIP_MANAGEMENT_SAVE_SUCCESS: 'POOL_MEMBERSHIP_MANAGEMENT_SAVE_SUCCESS',
  POOL_MEMBERSHIP_MANAGEMENT_SAVE_FAILURE: 'POOL_MEMBERSHIP_MANAGEMENT_SAVE_FAILURE',
};
